/* PSB - pastilles couleur nettes.
   Les pastilles (app Product Colors) sont affichees en zoom 400 % (custom CSS), ce qui floute les images
   sources de petite taille (56-200 px). Ce script mesure l'image reelle de chaque pastille et limite le zoom
   pour ne jamais agrandir l'image au-dela de sa resolution (ecran Retina inclus). Les images 500 px gardent le
   zoom 400 %. Supprimer la ligne <script> dans layout/theme.liquid = retour a l'etat d'origine. */
(function () {
  var SEL = 'linkify-product-colors-swatch[data-type="image"]';
  var sizes = {};
  var dpr = Math.max(1, window.devicePixelRatio || 1);
  var st = document.createElement('style');
  st.textContent = SEL + '[data-psb-size][data-psb-size]:before{background-size:var(--psb-bg-size)!important}';
  document.head.appendChild(st);

  function urlOf(el) {
    var m = /url\(['"]?([^'")]+)/.exec(el.getAttribute('style') || '');
    return m ? m[1] : null;
  }
  function apply(el, w) {
    var box = el.getBoundingClientRect().width;
    if (!box) return false;
    var pct = (w / (box * dpr)) * 100;
    if (pct >= 400) { el.removeAttribute('data-psb-size'); return true; }
    el.style.setProperty('--psb-bg-size', pct <= 110 ? 'cover' : Math.round(pct) + '%');
    el.setAttribute('data-psb-size', '1');
    return true;
  }
  function process(el) {
    var u = urlOf(el);
    if (!u) return;
    if (sizes[u]) { if (sizes[u] > 0) apply(el, sizes[u]); return; }
    if (sizes[u] === 0) return;
    sizes[u] = 0;
    var im = new Image();
    im.onload = function () {
      sizes[u] = Math.max(im.naturalWidth, 1);
      document.querySelectorAll(SEL).forEach(function (e) { if (urlOf(e) === u) apply(e, sizes[u]); });
    };
    im.onerror = function () { delete sizes[u]; };
    im.src = u;
  }
  var timer;
  function scan() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.querySelectorAll(SEL).forEach(function (el) {
        var u = urlOf(el);
        if (u && sizes[u] > 0) apply(el, sizes[u]); else process(el);
      });
    }, 120);
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'data-plp-capped'] });
  window.addEventListener('resize', scan);
  scan();
})();
